export { Period };
var Period;
(function (Period) {
    Period[Period["FirstDayOfYear"] = 0] = "FirstDayOfYear";
    Period[Period["January"] = 1] = "January";
    Period[Period["February"] = 2] = "February";
    Period[Period["March"] = 3] = "March";
    Period[Period["April"] = 4] = "April";
    Period[Period["May"] = 5] = "May";
    Period[Period["June"] = 6] = "June";
    Period[Period["July"] = 7] = "July";
    Period[Period["August"] = 8] = "August";
    Period[Period["September"] = 9] = "September";
    Period[Period["October"] = 10] = "October";
    Period[Period["November"] = 11] = "November";
    Period[Period["December"] = 12] = "December";
    Period[Period["LastDayOfYear"] = 13] = "LastDayOfYear";
})(Period || (Period = {}));
export { ExtraPeriod };
var ExtraPeriod;
(function (ExtraPeriod) {
    ExtraPeriod["AllYear"] = null;
    if (typeof ExtraPeriod.AllYear !== "string") ExtraPeriod[ExtraPeriod.AllYear] = "AllYear";
})(ExtraPeriod || (ExtraPeriod = {}));
export const constructDate = (year, period, day) => {
    switch (period) {
        case Period.FirstDayOfYear:
            return new Date(year, 0, 1, 4, 0, 0, 0);
        case Period.LastDayOfYear:
            return new Date(year, 11, 31, 20, 0, 0, 0);
        default:
            return new Date(year, period - 1, day || 1, 12, 0, 0, 0);
    }
};
export const getMonthAndDay = (period) => {
    switch (period) {
        case Period.FirstDayOfYear:
            return { month: 0, day: 1 };
        case Period.LastDayOfYear:
            return { month: 11, day: 31 };
        default:
            return { month: period - 1 };
    }
};
//# sourceMappingURL=Periods.js.map